<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">退房清洁订单详情</div>
      <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">订单号：{{orderDetail.order_id}}</h2>
          <h2 class="weui-msg__title">{{order_status()}}</h2>
          <div class="notice-yellow" v-if="orderDetail.pay_status==0">请在{{orderDetail.expiration_time| moment("HH点mm分")}}前完成支付，否则订单将失效</div>

          <h2 class="weui-msg__title"  v-if="orderDetail.pay_status==2">待支付金额：<span class="color-orange">{{orderDetail.payment_amount | numeral('$0,0.00')}}</span></h2>
      </div>

      <div class="weui-cells__title" v-if="orderDetail.pay_status==2||orderDetail.pay_status==3||orderDetail.pay_status==4">费用详情</div>

      <div class="weui-cells" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>总费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.order_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>定金</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.deposit_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>服务尾款</p>
            </div>
            <div class="weui-cell__ft">{{(orderDetail.order_amount - orderDetail.deposit_amount)  | numeral('$0,0.00')}}</div>
        </a>
        <label class="weui-cell weui-check__label car" v-if="Number(orderDetail.gst_amount) > 0">
            <div class="weui-cell__bd">
                <p class="park-assist" @click="getInvoice()"> <span class="icon-fapiao parking-icon"></span> 点击下载 Invoice </p>
            </div>
        </label>
      </div>

      <div class="weui-cells" v-if="orderDetail.pay_status==2">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>总费用</p>
            </div>
            <div class="weui-cell__ft">{{Number(orderDetail.payment_amount) + Number(orderDetail.deposit_amount) | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>已付定金</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.deposit_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>需支付费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.payment_amount | numeral('$0,0.00')}}</div>
        </a>
      </div>

      <div class="weui-cells" v-if="orderDetail.pay_status==2||orderDetail.pay_status==3||orderDetail.pay_status==4">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.labor_cost  | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>复式户型费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.duplex_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>地毯清洁费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.carpet_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>特殊区域清洁费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.special_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>额外清洁项目</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.extra_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.gst_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>其他费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>优惠减免</p>
            </div>
            <div class="weui-cell__ft">-{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <router-link :to="pricingURL"><p class="park-assist"> <span class="icon-info parking-icon"></span> 点击查看费用细节清单 </p></router-link>
            </div>
        </label>
      </div>

      <div class="weui-cells__title" v-if="orderDetail.pay_status==0||orderDetail.pay_status==1">预计价格（仅作参考，以实际服务为准）</div>
      <div class="weui-cells" v-if="orderDetail.pay_status==0 ">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost">{{pricing.labor_cost | numeral('$0,0.00')}}</div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost==0">户型特殊，客服将电话回访报价</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.duplex_cost">
            <div class="weui-cell__bd">
                <p>复式户型费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.duplex_cost">{{pricing.duplex_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.carpet_cost">
            <div class="weui-cell__bd">
                <p>地毯清洁费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.carpet_cost">{{pricing.carpet_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="pricing.special_cost">
            <div class="weui-cell__bd">
                <p>特殊区域：车库</p>
            </div>
            <div class="weui-cell__ft">
              <span>{{pricing.special_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="this.orderDetail.details.attribute.storage>0||this.orderDetail.details.attribute.swimming_pool>0||this.orderDetail.details.attribute.forecourt>0||this.orderDetail.details.attribute.backyard>0">
            <div class="weui-cell__bd">
                <p>
                  <span v-show="this.orderDetail.details.attribute.storage>0">仓库 </span>
                  <span v-show="this.orderDetail.details.attribute.swimming_pool>0">泳池 </span>
                  <span v-show="this.orderDetail.details.attribute.forecourt>0">前院 </span>
                  <span v-show="this.orderDetail.details.attribute.backyard>0">后院 </span>
                </p>
            </div>
            <div class="weui-cell__ft" >视现场情况收费</div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <p class="park-assist" @click="goto('/clean-pricing')"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p>
            </div>
        </label>
      </div>
      <div class="weui-cells" v-if="orderDetail.pay_status==1 ">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost">{{pricing.labor_cost | numeral('$0,0.00')}}</div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost==0">户型特殊，客服将电话回访报价</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.duplex_cost">
            <div class="weui-cell__bd">
                <p>复式户型费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.duplex_cost">{{pricing.duplex_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.carpet_cost">
            <div class="weui-cell__bd">
                <p>地毯清洁费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.carpet_cost">{{pricing.carpet_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="pricing.special_cost">
            <div class="weui-cell__bd">
                <p>特殊区域：车库</p>
            </div>
            <div class="weui-cell__ft">
              <span>{{pricing.special_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="this.orderDetail.details.attribute.storage>0||this.orderDetail.details.attribute.swimming_pool>0||this.orderDetail.details.attribute.forecourt>0||this.orderDetail.details.attribute.backyard>0">
            <div class="weui-cell__bd">
                <p>
                  <span v-show="this.orderDetail.details.attribute.storage>0">仓库 </span>
                  <span v-show="this.orderDetail.details.attribute.swimming_pool>0">泳池 </span>
                  <span v-show="this.orderDetail.details.attribute.forecourt>0">前院 </span>
                  <span v-show="this.orderDetail.details.attribute.backyard>0">后院 </span>
                </p>
            </div>
            <div class="weui-cell__ft" >视现场情况收费</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>额外清洁项目</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.extra_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">总费用10%</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>其他费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>优惠减免</p>
            </div>
            <div class="weui-cell__ft">-{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <router-link :to="pricingURL"><p class="park-assist"> <span class="icon-info parking-icon"></span> 点击查看费用细节清单 </p></router-link>
            </div>
        </label>
      </div>

      <div class="weui-cells__title">服务详情</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>清洁户型</p>
            </div>
            <div class="weui-cell__ft">{{house_type_duplex}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>清洁房间</p>
            </div>
            <div class="weui-cell__ft">{{room_qty}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>特殊区域</p>
            </div>
            <div class="weui-cell__ft">{{sp_room}}</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.service_date| moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>

        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>服务地址</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.address.address_street}}, {{orderDetail.details.address.address_suburb}}, {{orderDetail.details.address.address_state}}, {{orderDetail.details.address.address_postcode}}<br>{{dataLint("floor",orderDetail.details.floor)}} {{dataLint("parking",orderDetail.details.parking)}}</div>
        </a>

      </div>

      
      <div class="btn-box" v-if="orderDetail.pay_status==1||orderDetail.pay_status==3||orderDetail.pay_status==4||orderDetail.pay_status==5">
        <div class="btn active" @click="goback()">返回</div>
      </div>
      
      <div v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
        <br>
      </div>

      <div class="btn-box-fix" v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
        <div class="btn-container">
          <div class="btn active" @click="checkSubmit()">立即支付</div>
        </div>
      </div>

      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>

      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取订单</p>
              </div>
          </div>
      </transition>

      <div class="js_dialog" v-show="isLeaving">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">尚未完成支付</strong></div>
              <div class="weui-dialog__bd">确定要离开订单详情页吗？离开后需要登录账号才可以完成支付</div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="goto('/login')">离开</a>
                  <div  class="weui-dialog__btn weui-dialog__btn_daojia" @click="checkSubmit()">立即支付</div>
              </div>
          </div>
      </div>


    </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      isLeaving:false,
      pricing:{},
      orderDetail:{
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": null,
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
              "type_id": "",
              "floor": "",
              "duplex_floor": "",
              "carpet":"",
              "livingroom": "",
              "bedroom": "",
              "bathroom": "",
              "toiletroom": "",
              "garage": "",
              "is_return": "",
              "operates_num": ""
        },
        "details": {
              "house_type": "",
              "address": {
                  "address_name": "",
                  "address_phone": "",
                  "address_state": "",
                  "address_suburb": "",
                  "address_street": "",
                  "address_postcode": ""
              },
              "floor": "",
              "parking": "",
              "is_duplex": "",
              "duplex_floor": "",
              "labor_cost": "",
              "duplex_cost": "",
              "special_cost": "",
              "extra_cost": "",
              "extra_data": [],
              "service_start_time": "",
              "service_end_time": "",
              "service_pause_time": "",
              "service_pause_second": "",
              "service_period": "",
              "house_type_name": "",
              "floor_name": "",
              "parking_name": "",
              "attribute": {
                  "livingroom": "",
                  "bedroom": "",
                  "bathroom": "",
                  "toiletroom": "",
                  "study": "",
                  "balcony": "",
                  "garage": "",
                  "storage": "",
                  "swimming_pool": "",
                  "forecourt": "",
                  "backyard": ""
              }
        },
        "expiration_time": 0
      }
    }
  },
  methods: {
    order_status: function () {
      let result = '';
      switch (this.orderDetail.pay_status) {
        case "0":
          result = '订单已确认，待支付定金 $'+this.orderDetail.deposit_amount;
          break;
        case "1":
          result = '已付定金，等待服务'
          break;
        case "2":
          result = '服务完毕，待支付全款'
          break;
        case "3":
          result = '已付款，等待确认到账'
          break;
        case "4":
          result = '已付款完毕，感谢使用我们的服务'
          break;
        case "5":
          result = '已退款'
          break;
        default:
          console.log("订单状态异常");
      }
      return result;
    },
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            if(that.orderDetail.lifecycle_status==1){
              that.$router.push('/order-cancel?reason=timeout');
            }
            if(that.orderDetail.order_status==8){
              that.$router.push('/order-cancel');
            }
            if(that.orderDetail.pay_status==0||that.orderDetail.pay_status==1){
              that.getPricing();
            }
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    getPricing(){
      if(this.isSendingPricing){
        return false;
      }
      else{
        this.isSendingPricing = true;
        let that = this;

        //做对象的副本出来
        let orderObject = this.orderDetail.cost_data;
        this.axios.post(this.apiURL()+'/Cost/getCost', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.pricing = response.data.data;
            that.isSendingPricing=false;
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSendingPricing=false;
          }
        })
        .catch(function (error) {
          alert("获取报价失败，请检查网络并尝试刷新页面")
          that.isSendingPricing=false;
          console.log(error);
        });
      }
    },
    getInvoice(){
      if(this.orderDetail.invoices_url){
          window.open(this.orderDetail.invoices_url,'_blank');
      }
      else{
        this.$router.push(this.invoiceURL);
      }
    },
    checkSubmit(){
      if(this.orderDetail.pay_status==0){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&status=0&amount='+this.depositAmount());
      }
      if(this.orderDetail.pay_status==2){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&status=2&amount='+this.orderDetail.payment_amount);
      }
    },
    goback(){
      if(this.orderDetail.pay_status==0&&!localStorage.token){
        this.isLeaving = true;
      }
      else{
        this.$router.push('/order');
      }
    },
    dataLint(name,value){
      let result ="";

      if (name == "duplex_floor"){
        switch (value) {
          case "0":
            result = "0"
            break;
          case "1558077283":
            result = "2"
            break;
          case "1558077310":
            result = "3"
            break;
          case "1558077329":
            result = "4"
            break;
          case "1558077340":
            result = "5"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "house_type"){
        switch (value) {
          case "1552109724":
            result = "1"
            break;
          case "1552109729":
            result = "2"
            break;
          case "1552109735":
            result = "3"
            break;
          case "1552109742":
            result = "4"
            break;
          case "1558079273":
            result = "5"
            break;
          case "1552109747":
            result = "6"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "parking") {
        switch (value) {
          case "1551410080":
            result = "我有停车位"
            break;
          case "1551410087":
            result = "已约停车位"
            break;
          case "1551410093":
            result = "无法提供停车位"
            break;
          default:
            console.log("6");
        }
      }

      if (name == "floor") {
        switch (value) {
          case "1551412462":
            result = "有电梯/住G层"
            break;
          case "1551412475":
            result = "1层 无电梯"
            break;
          case "1551412486":
            result = "2层 无电梯"
            break;
          case "1551412499":
            result = "3层 无电梯"
            break;
          case "1551412509":
            result = "4层 无电梯"
            break;
          case "1551412525":
            result = "5层 无电梯"
            break;
          case "1551412535":
            result = "5层以上 无电梯"
            break;
          default:
            console.log("7");
        }
      }

      if (name == "carpet") {
        switch (value) {
          case 0:
            result = "0"
            break;
          case 1:
            result = "1564040798"
            break;
          case 2:
            result = "1564040821"
            break;
          case 3:
            result = "1564040831"
            break;
          case 4:
            result = "1564040842"
            break;
          case 5:
            result = "1564040857"
            break;
          default:
            console.log("8");
        }
      }
      
      return result;
    },

  },
  components: {
  },
  computed: {
    orderIDFromURL: function (){
      let theString = this.$route.query.id;
      if(theString.includes("?")){
        return theString.substring(0, theString.indexOf('?'));
      }
      else{
        return theString;
      }
    },
    service_period: function () {
      let result = '';
      switch (this.orderDetail.details.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    pricingURL: function (){
      let theString = this.$route.query.id;
      return '/clean/order-detail/price?id=' + theString;
    },
    invoiceURL: function (){
      let theString = this.$route.query.id;
      return '/clean/order-detail/invoice?id=' + theString;
    },
    house_type_duplex: function () {
      let type = this.orderDetail.details.house_type_name;
      let duplex = '';
      
      switch (this.orderDetail.details.is_duplex) {
        case "0":
          duplex = '非复式'
          break;
        case "1":
          duplex = '复式'
          break;
        default:
          console.log("2");
      }
      let result = type + " " + duplex;
      if(this.orderDetail.details.is_duplex=="1"){
        result = result + this.dataLint("duplex_floor",this.orderDetail.details.duplex_floor) + "层";
      }
      return result;
    },
    room_qty: function () {
      let result = this.orderDetail.details.attribute.livingroom + '厅 ' + this.orderDetail.details.attribute.bedroom + '室 ' + this.orderDetail.details.attribute.bathroom + '卫浴 ' + this.orderDetail.details.attribute.toiletroom + '厕所 ';
      if(this.orderDetail.details.carpet_name){
        result = result + this.orderDetail.details.carpet_name;
      }
      return result;
    },
    sp_room: function () {
      let result ='';

      if(this.orderDetail.details.attribute.garage>0){
        result = result + this.orderDetail.details.attribute.garage + '车库 ';
      }
      if(this.orderDetail.details.attribute.storage>0){
        result = result + this.orderDetail.details.attribute.storage + '仓库 ';
      }
      if(this.orderDetail.details.attribute.swimming_pool>0){
        result = result + this.orderDetail.details.attribute.swimming_pool + '泳池 ';
      }
      if(this.orderDetail.details.attribute.forecourt>0){
        result = result + this.orderDetail.details.attribute.forecourt + '前院 ';
      }
      if(this.orderDetail.details.attribute.backyard>0){
        result = result + this.orderDetail.details.attribute.backyard + '后院 ';
      }
      if(result==''){
        result = "无";
      }
      return result;
    },

  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/clean/order-detail.vue